import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "Header" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "Title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
      _createVNode(_component_Close)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "VerticalLine" }, null, -1 /* CACHED */)),
    _createElementVNode("h2", {
      class: _normalizeClass([
			'Subtitle',
			_ctx.isRouteOverview ? 'SubtitleInvisible' : ''
		])
    }, _toDisplayString(_ctx.subtitle), 3 /* TEXT, CLASS */)
  ]))
}